export enum NewsPriority {
  Low = "کم",
  Moderate = "متوسط",
  High = "زیاد",
  Hot = "داغ",
  Critical = "بحرانی",
}
